//
export default [
    {
        text: "código(s) upc",
        value: "upc_codes",
        width: "10%",
        component: {
            type: "chip-list",
        },
    },
    {
        text: "código interno",
        value: "internal_code",
        width: "15%",
    },
    {
        text: "alias",
        value: "alias_name",
        width: "15%",
    },
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "stock esperado",
        //value: whProduct => whProduct.getStockByWarehouse(whWarehouseId),
        value: "stock_from_global_warehouse",
        align: "right",
        width: "15%",
    },
    {
        text: "stock",
        value: "stock",
        align: "right",
        width: "15%",
    },
]